import { render, staticRenderFns } from "./JourneyConnectionName.vue?vue&type=template&id=368e1099&scoped=true&"
import script from "./JourneyConnectionName.vue?vue&type=script&lang=js&"
export * from "./JourneyConnectionName.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "368e1099",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("n:\\Projects\\Werk\\MarketingDbNEW\\MarketingDb.Web.Zeiss\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('368e1099')) {
      api.createRecord('368e1099', component.options)
    } else {
      api.reload('368e1099', component.options)
    }
    module.hot.accept("./JourneyConnectionName.vue?vue&type=template&id=368e1099&scoped=true&", function () {
      api.rerender('368e1099', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "ScriptsV2/Core/Modules/JourneyBuilder/Components/Composer/JourneyConnection/GeneralSettings/JourneyConnectionName.vue"
export default component.exports